import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnnouncementBannerContainer } from '@insolution/announcement-feature';
import { Toasts } from '@insolution/core-ui';
import { EAnnouncementAppType } from '@insolution/graphql-data-access';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@insolution/language-data-access';
import { AuthService } from '@insolution/auth-data-access';

@Component({
  imports: [RouterModule, Toasts, AnnouncementBannerContainer],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected announcementAppType = EAnnouncementAppType.Workshop;

  private translateService = inject(TranslateService);
  private languageService = inject(LanguageService);
  private authService = inject(AuthService);

  protected isLoggedIn = this.authService.isLoggedIn;

  constructor() {
    this.translateService.addLangs(['nl-NL', 'de-DE', 'en-US', 'fr-FR', 'fi-FI']);
    this.translateService.setFallbackLang('en-US');

    this.setLanguage();
  }

  private async setLanguage() {
    await this.authService.waitForLoginStatus();
    this.languageService.storeLanguageOnChange();
  }
}
